// extracted by mini-css-extract-plugin
export var avatarContainer = "_8t-0";
export var avatarTypingWave = "_8t-i";
export var gray = "_8t-f";
export var green = "_8t-c";
export var icon = "_8t-9";
export var image = "_8t-1";
export var lg = "_8t-6";
export var md = "_8t-5";
export var presenceDot = "_8t-b";
export var red = "_8t-d";
export var sm = "_8t-4";
export var status = "_8t-a";
export var typingDot = "_8t-h";
export var typingPill = "_8t-g";
export var xl = "_8t-7";
export var xs = "_8t-3";
export var xxl = "_8t-8";
export var xxs = "_8t-2";
export var yellow = "_8t-e";